import * as yup from "yup";

import { Translations, i18n } from "@i18n";
import { GoalNameFormValues } from "./types";

export const validationSchema: yup.SchemaOf<GoalNameFormValues> = yup.object().shape({
  goalName: yup.string().required(i18n.t(Translations.GoalNameRouteInputRequired)),
});
